import { getMessages, root } from '../../../../../store/constants';

export const onUpgradeApply = () => {
    root.App.controller.showPayment();
    root.App.controller.trackEvent(
        getMessages().getText('ga.category.subscription'),
        getMessages().getText('ga.action.snackbar.upgrade')
    );
}
